import { type FC } from 'react'
import { FormattedNumber } from 'react-intl'

import { useGlobalConfigContext } from '../../../global-config'
import { TENANT } from '../../../tenant'
import { productAccessorGetDiscountFromOffer } from '../../model/productAccessor/productAccessorGetDiscountFromOffer'
import { ProductBadge } from '../ProductBadge'
import { useProductPageContext } from '../productPageContext'

export const ProductDiscountBadge: FC = () => {
  const { tenant } = useGlobalConfigContext()

  const { currentOffer, currentPrescriptionType } = useProductPageContext()

  const discount = currentOffer
    ? productAccessorGetDiscountFromOffer({
        currentPrescriptionType,
        offer: currentOffer,
        tenant,
      })
    : 0

  if (!discount || tenant !== TENANT.IT) {
    return null
  }

  return (
    <ProductBadge className="relative -mb-4 bg-gradient-radial-light-tertiary text-m">
      <FormattedNumber style="percent" value={-discount / 100} />
    </ProductBadge>
  )
}
